import usePrevState from '@hooks/usePrevState';
import { FavoritePrepaidCardRow } from '@models/prepaidCard';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

import { currentCardAtom } from '../../../atoms/prepaidCardAtoms';

interface Props {
    cards: FavoritePrepaidCardRow[];
}

function useRolling({ cards }: Props) {
    const slideCount = cards.length + 1; // 마지막은 새 카드 구매
    const prevCards = usePrevState(cards);
    const [index, setIndex] = useState(0);
    const setCurrent = useSetAtom(currentCardAtom);
    const isBuySlot = index >= cards.length;

    const move = (i: number) => {
        if (slideCount === 0) return;
        setIndex(((i % slideCount) + slideCount) % slideCount);
    };

    const moveNext = () => move(index + 1);
    const movePrev = () => move(index - 1);

    useEffect(() => {
        setCurrent(isBuySlot ? undefined : cards[index]);
    }, [cards, index, isBuySlot, setCurrent]);

    useEffect(() => {
        const prev = prevCards.map((it) => it.id).join(',');
        const current = cards.map((it) => it.id).join(',');
        if (prev !== current) {
            setIndex(0);
        }
    }, [prevCards, cards]);

    return {
        index,
        slideCount,
        isBuySlot,
        move,
        moveNext,
        movePrev,
    };
}

export default useRolling;
